import { Routes } from '@angular/router';

export const homeRoutes: Routes = [
    {
      path: '',
      redirectTo: 'message-center',
      pathMatch: 'full',
    },
    {
      path: 'message-center',
      loadComponent: () =>
      import('./message-center/message-center.component').then(
        (m) => m.MessageCenterComponent
      ),
    },
    {
      path: 'services-builder',
      loadComponent: () =>
      import('./services-builder/services-builder.component').then(
        (m) => m.ServicesBuilderComponent
      ),
    },
    {
      path: 'custom-responses',
      loadComponent: () =>
      import('./custom-responses/custom-responses.component').then(
        (m) => m.CustomResponsesComponent
      ),
    },
    {
      path: 'survey-builder',
      redirectTo: 'services-builder',
      pathMatch: 'full',
    },
    {
      path: 'surveys',
      loadComponent: () =>
      import('./surveys/surveys.component').then(
        (m) => m.SurveysComponent
      ),
    },
    {
      path: 'users',
      loadComponent: () =>
      import('./users/users.component').then(
        (m) => m.UsersComponent
      ),
    },
    {
      path: 'dashboard',
      loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    }
  ];
